import { initialState as AuthInitialState } from './reducers/auth/Auth'
import { initialState as DashboardInitialState } from './reducers/dashboard/Dashboard'

export const initialState = {
  Auth:       AuthInitialState,
  Dashboard:  DashboardInitialState,
}
